import { TFunction } from 'i18next';
import * as yup from 'yup';

export const getLocalizedSchema = (t: TFunction): yup.ObjectSchema<{ clientID: string }> =>
  yup
    .object({
      clientID: yup.string().required(t('form.validation.profileIsRequired')),
    })
    .required();

export type FormData = yup.InferType<ReturnType<typeof getLocalizedSchema>>;
